// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithTagName } from "./Dom";
import { FormField } from "./WebSite.Form.Field";
import { ControlMode } from "./WebSite.Page.Component";

export class MultipleSelectButtons extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.buttons = null;

    if (this.mode === ControlMode.edit) {
      this.buttons = new Array();
      this.initialize();
      this.attachHandlers();

      if (this.buttons.length > 0)
        this.buttons[0].element.tabIndex = 0;
    }
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit)
      this.input.addEventListener(event, handler);
  }

  attachHandlers() {
    for (const button of this.buttons) {
      button.element.addEventListener("click", this.createToggleButtonHandler(button));
      button.element.addEventListener("keydown", this.createKeyHandler(button));
    }

    this.addValueChangedHandler(this.input);
  }

  createKeyHandler(button) {
    return (event) => {
      if (!this.disabled)
        this.handleKey(button, event);
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  }

  createToggleButtonHandler(button) {
    return (event) => {
      if (!this.disabled) {
        if (event.shiftKey) {
          for (const other of this.buttons)
            if (other.selected)
              other.toggle();

          if (!button.selected)
            button.toggle();

          this.recalculate();
        }
        else
          this.toggle(button);
      }
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  focus() {
    this.buttons[0].element.focus();
  }

  focusNext(button) {
    var target = button.element.nextSibling;

    if (target !== null && target.tagName === "BUTTON")
      target.focus();
  }

  focusPrevious(button) {
    var target = button.element.previousSibling;

    if (target !== null && target.tagName === "BUTTON")
      target.focus();
  }

  getValue() {
    return this.input.value;
  }

  handleKey(button, event) {
    var result = false;

    if (event.code === "Space") {
      event.preventDefault();
    }
    else if (event.code === "ArrowLeft") {
      this.focusPrevious(button);
      event.preventDefault();
    }
    else if (event.code === "ArrowRight") {
      this.focusNext(button);
      event.preventDefault();
    }
    else if (event.code === "Home") {
      this.buttons[0].element.focus();
      event.preventDefault();
    }
    else if (event.code === "End") {
      this.buttons[this.buttons.length - 1].element.focus();
      event.preventDefault();
    }
    else if (event.ctrlKey && event.code === "KeyA") {
      this.selectAll();
      event.preventDefault();
    }

    return result;
  }

  initialize() {
    var query = new DomQuery(this.element);
    var buttons = query.getDescendants(WithTagName("BUTTON"));

    for (var button of buttons)
      this.buttons.push(new MultipleSelectButton(button));

    this.input = query.getDescendant(WithTagName("INPUT"));
  }

  recalculate() {
    var values = new Array();

    for (var button of this.buttons)
      if (button.selected)
        values.push(button.value);

    this.updateFieldValue(values.join(","));
  }

  selectAll() {
    for (var button of this.buttons)
      if (!button.selected)
        button.toggle();

    this.recalculate();
  }

  updateFieldValue(value) {
    this.input.value = value;

    this.input.dispatchEvent(new Event("input"));
    this.input.dispatchEvent(new Event("change"));
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;

    if (this.buttons !== null)
      for (const button of this.buttons)
        button.element.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      const values = new Set(fieldValue.split(","));

      this.buttons.forEach(
        button => {
          if (values.has(button.value) !== button.selected)
            button.toggle();
        }
      );

      this.updateFieldValue(fieldValue);
    }
  }

  toggle(button) {
    button.toggle();
    this.recalculate();
  }

  get disabled() {
    return (this.input === null || this.input.disabled);
  }
}

class MultipleSelectButton {
  constructor(element) {
    this.element = element;
    this.element.tabIndex = -1;

    this.value = this.element.dataset.Value;
    this.selected = element.classList.contains("Selected");

    this.classSwitch = new HtmlClassSwitch(this.element, "Selected");
    this.selected = this.classSwitch.getStatus();
  }

  toggle() {
    this.selected = !this.selected;

    this.classSwitch.setStatus(this.selected);
    this.element.setAttribute("aria-selected", this.selected);
  }
}

interactivityRegistration.register("MultipleSelectButtons", function (element) { return new MultipleSelectButtons(element); });
